import { useEffect, useState } from "react";
// import { getProfileApi, updateOwnProfileApi } from "../../app/api";
import { getUserByIdApi, updateOwnProfileApi } from "../../app/api";


import { toast } from "react-toastify";
import {
  Mail,
  Phone,
  Calendar,
  Briefcase,
  User,
  Shield,
  Fingerprint,
  AlertCircle,
} from "lucide-react";

import Attendance from "../profile/AttendanceProfile";
import UserLeavesProfile from "../profile/UserLeavesProfile";
import MyLeaves from "../../pages/leaves/MyLeaves";
// import TaskDetailsMy from "../../pages/dashboard/components/TaskDetailsMy";
import UserTaskBoard from "../../pages/dashboard/components/UserTaskBoard";
import { createPortal } from "react-dom";
import UserJourney from "../../components/Tasks/UserJourney";

import { useAuth } from "../../app/store";
import { LogOut } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";


const IMAGE_BASE = "https://uptask.visiontrek.io";

export default function Profile() {
  // const { logout } = useAuth();
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // const [activeTab, setActiveTab] = useState("profile");
  const [activeTab, setActiveTab] = useState("profile");
  const [selectedTaskId, setSelectedTaskId] = useState(null);

  useEffect(() => {
    if (location.state?.tab) {
      setActiveTab(location.state.tab);
    }

    if (location.state?.taskId) {
      setSelectedTaskId(location.state.taskId);
    }
  }, [location.state]);


  const [editMode, setEditMode] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [form, setForm] = useState({});
  const [modal, setModal] = useState({
    show: false,
    success: false,
    message: "",
  });
  const [data, setData] = useState(null);

  useEffect(() => {
    if (user?.id) {
      loadProfile();
    }
  }, [user]);



  const loadProfile = async () => {
    if (!user?.id) return;

    const res = await getUserByIdApi();

    if (res.success) {
      const userData = res.data.find(u => u.id === user.id);

      if (!userData) {
        console.error("User not found");
        return;
      }

      setData(userData);

      setForm({
        emp_id: userData.emp_id || "",
        email: userData.email || "",
        first_name: userData.first_name || "",
        last_name: userData.last_name || "",
        phone_number: userData.phone_number || "",
        alter_contact_name: userData.alter_contact_name || "",
        alter_number: userData.alter_number || "",
        department_id: userData.department_id || "",
        job_title: userData.job_title || "",
        dob: userData.dob || "",
        address: userData.address || "",
        // biometric_id: userData.biometric_id || "",
        gender: userData.gender || "",
        joined_at: userData.joined_at?.split(" ")[0] || "",
      });
    }
  };


  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) =>
      formData.append(key, value ?? "")
    );

    // ✅ ADD THIS
    formData.append("user_id", user.id);

    // if (profileImage) {
    //   formData.append("profile_pic", profileImage);
    // }
    if (profileImage) {
      const webpImage = await convertToWebP(profileImage);
      formData.append("profile_pic", webpImage);
    }
    const res = await updateOwnProfileApi(formData);

    if (res.success) {
      setModal({
        show: true,
        success: true,
        message: "Profile updated successfully",


      });
      setEditMode(false);
      setProfileImage(null);
      loadProfile();

      // ✅ Auto reload after 1.5 sec
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      setModal({
        show: true,
        success: false,
        message: res.message || "Update failed",
      });
    }
  };

  if (!data) {
    return (
      <div className="mt-20 text-white text-center opacity-60">
        Loading profile...
      </div>
    );
  }



  const convertToWebP = (file, maxWidth = 800) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) return reject("Conversion failed");

            resolve(
              new File([blob], file.name.replace(/\.[^/.]+$/, ".webp"), {
                type: "image/webp",
              })
            );
          },
          "image/webp",
          0.8
        );
      };

      img.onerror = reject;
      img.src = URL.createObjectURL(file);
    });
  };


  return (
    <div className="max-w-7xl mx-auto px-4 py-6 bg-[#f3f4f8] rounded-3xl">
      {/* ===== HERO ===== */}
      <div className="
        relative rounded-3xl p-6 md:p-8 mb-10
         bg-[#12082F]
  backdrop-blur-2xl text-white
  border border-white/10
  shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)] md:mt-14
      ">
        <div className="flex flex-col md:flex-row md:items-center gap-6">
          {/* Avatar */}
          <div className="w-24 h-24 rounded-full border-4 border-white/20 overflow-hidden bg-white/10">
            <img
              src={
                data.profile_pic
                  ? `${IMAGE_BASE}${data.profile_pic}`
                  : "/avatar.png"
              }
              className="w-full h-full object-cover"
              alt="profile"
            />
          </div>

          {/* Info */}
          <div className="flex-1">
            <h2 className="text-2xl font-semibold">
              {data.first_name} {data.last_name}
            </h2>
            <p className="text-sm opacity-80">{data.job_title}</p>

            <div className="flex gap-2 mt-2 text-xs">
              <span className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300">
                Role ID: {data.role_id}
              </span>
              <span
                className={`px-3 py-1 rounded-full text-xs ${data.is_active
                  ? "bg-green-500/20 text-green-300"
                  : "bg-red-500/20 text-red-300"
                  }`}
              >
                {data.is_active ? "Active" : "Inactive"}
              </span>
            </div>
          </div>

          <button
            onClick={() => setEditMode(true)}
            className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm"
          >
            Update Profile
          </button>
        </div>
      </div>

      <ResponseModal
        show={modal.show}
        success={modal.success}
        message={modal.message}
        onClose={() => setModal({ ...modal, show: false })}
      />

      <EditProfileModal
        show={editMode}
        onClose={() => {
          setEditMode(false);
          setProfileImage(null);
        }}
        form={form}
        handleChange={(e) =>
          setForm({ ...form, [e.target.name]: e.target.value })
        }
        handleUpdate={handleUpdate}
        profileImage={profileImage}
        setProfileImage={setProfileImage}
        currentImage={data?.profile_pic}
      />

      <div className="flex gap-2 md:gap-4 mb-6 overflow-x-auto no-scrollbar p-2 ">
        {["profile", "attendance", "leave", "task", "journey"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`
              px-6 py-2 text-sm font-semibold uppercase tracking-wide
              rounded-full transition-all duration-300
              ${activeTab === tab
                ? "bg-gradient-to-r from-purple-500 to-purple-700 text-white shadow-lg scale-105"
                : "bg-[#dbc4f2] text-[#5f1ea0] hover:bg-purple-200 shadow-lg"
              }
            `}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* ===== CONTENT ===== */}
      {activeTab === "profile" && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <GlassCard title="Basic Information">
            <Stat label="Email" value={data.email} />
            <Stat label="Phone" value={data.phone_number || "Not provided"} />
            <Stat label="Gender" value={data.gender || "—"} />
            <Stat label="Job Title" value={data.job_title} />
          </GlassCard>

          <GlassCard title="Emergency Contact">
            <Stat label="Alternate Contact Name" value={data.alter_contact_name || "Not set"} />
            <Stat label="Alternate Contact Number" value={data.alter_number || "Not set"} />
          </GlassCard>

          <GlassCard title="Account">
            <Stat label="Employee ID" value={data.emp_id} />
            <Stat label="Role ID" value={data.role_id} />
            <Stat label="Joined" value={data.joined_at?.split(" ")[0] || "—"} />
            <Stat label="Date of Birth" value={data.dob || "Not provided"} />
          </GlassCard>
        </div>
      )}

      {activeTab === "attendance" && (
        <div className="
          rounded-2xl p-5 mt-4
       bg-[#12082F]
  backdrop-blur-2xl text-white
  border border-white/10
  shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
        ">
          <Attendance />
        </div>
      )}

      {activeTab === "leave" && (
        <div className="md:mt-[-44px]">
          <MyLeaves />
        </div>
      )}

      {activeTab === "task" && (
        <div className="mt-4 p-4 rounded-2xl   bg-[#12082F]
  backdrop-blur-2xl text-white
  border border-white/10
  shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]">
          <UserTaskBoard userId={user.id} />
        </div>
      )}

      {activeTab === "journey" && (
        <div className="mt-4 p-6 rounded-3xl
  bg-[#12082F]
  backdrop-blur-2xl text-white
  border border-white/10
  shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
">
          <UserJourney userId={user.id} />
        </div>
      )}
    </div>
  );
}

/* ===== UI HELPERS ===== */

function GlassCard({ title, children }) {
  return (
    <div className="
      rounded-2xl p-5
     bg-[#12082F]
  backdrop-blur-2xl text-white
  border border-white/10
  shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]x
    ">
      <h3 className="font-semibold mb-4">{title}</h3>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <p className="text-xs opacity-60">{label}</p>
      <p className="font-medium">{value || "—"}</p>
    </div>
  );
}

/* ================= RESPONSE MODAL ================= */
function ResponseModal({ show, success, message, onClose }) {
  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-xl w-[320px] text-center">
        <h2 className={`text-xl font-bold mb-3 ${success ? "text-green-600" : "text-red-600"}`}>
          {success ? "Success" : "Failed"}
        </h2>

        <p className="text-gray-600 mb-4">{message}</p>

        <button
          onClick={onClose}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg w-full"
        >
          OK
        </button>
      </div>
    </div>,
    document.body
  );
}

/* ================= EDIT PROFILE MODAL ================= */
function EditProfileModal({
  show,
  onClose,
  form,
  handleChange,
  handleUpdate,
  profileImage,
  setProfileImage,
  currentImage,
}) {
  if (!show) return null;

  const IMAGE_BASE = "https://uptask.visiontrek.io";

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Glass Card */}
      <div
        className="
        relative w-full max-w-3xl max-h-[90vh] overflow-y-auto
        rounded-2xl p-8
        bg-white/10 backdrop-blur-xl
        border border-white/20
        shadow-2xl
        text-white
      "
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold">Update Profile</h2>
          <button
            onClick={onClose}
            className="text-white/70 hover:text-white text-xl"
          >
            ✕
          </button>
        </div>

        {/* Profile Image */}
        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-white/20">
              {profileImage ? (
                <img
                  src={URL.createObjectURL(profileImage)}
                  className="w-full h-full object-cover"
                />
              ) : currentImage ? (
                <img
                  src={`${IMAGE_BASE}${currentImage}`}
                  className="w-full h-full object-cover"
                />
              ) : null}
            </div>

            <label className="absolute bottom-0 right-0 bg-indigo-600 text-xs px-3 py-1 rounded-full cursor-pointer shadow-lg">
              Edit
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => setProfileImage(e.target.files[0])}
              />
            </label>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleUpdate} className="grid md:grid-cols-2 gap-4">
          <GlassInput label="Employee ID" name="emp_id" value={form.emp_id} disabled />
          <GlassInput label="Email" name="email" value={form.email} disabled />

          <GlassInput label="First Name" name="first_name" value={form.first_name} onChange={handleChange} />
          <GlassInput label="Last Name" name="last_name" value={form.last_name} onChange={handleChange} />

          <GlassInput label="Phone Number" name="phone_number" value={form.phone_number} onChange={handleChange} />
          <GlassInput label="Emergency Contact Name" name="alter_contact_name" value={form.alter_contact_name} onChange={handleChange} />

          <GlassInput label="Emergency Contact Number" name="alter_number" value={form.alter_number} onChange={handleChange} />

          <GlassInput label="Job Title" name="job_title" value={form.job_title} onChange={handleChange} />

          <GlassInput type="date" label="Date of Birth" name="dob" value={form.dob} onChange={handleChange} />
          <GlassInput
            type="date"
            label="Joining Date"
            name="joined_at"
            value={form.joined_at}
            onChange={handleChange}
          />
          <div className="md:col-span-2">
            <label className="text-xs text-white/70 mb-1 block">Address</label>
            <textarea
              name="address"
              value={form.address}
              onChange={handleChange}
              rows={3}
              className="w-full bg-white/10 border border-white/20 rounded-lg p-3 backdrop-blur-md focus:outline-none"
            />
          </div>

          <div className="md:col-span-2">
            <label className="text-xs text-white/70 mb-1 block">Gender</label>
            <select
              name="gender"
              value={form.gender}
              onChange={handleChange}
              className="w-full bg-white/10 border border-white/20 rounded-lg p-3 backdrop-blur-md focus:outline-none"
            >
              <option value="">Select</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>

          {/* Footer Buttons */}
          <div className="md:col-span-2 flex justify-end gap-4 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 rounded-lg bg-white/20 hover:bg-white/30 transition"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="px-6 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 transition"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}

function GlassInput({ label, ...props }) {
  return (
    <div>
      <label className="text-xs text-white/70 mb-1 block">{label}</label>
      <input
        {...props}
        className="
          w-full
          bg-white/10
          border border-white/20
          rounded-lg
          p-3
          backdrop-blur-md
          focus:outline-none
        "
      />
    </div>
  );
}
